import * as React from "react";
import { forwardRef } from "react";
const SvgLogoff = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.75 14.75h-3a1.5 1.5 0 0 1-1.5-1.5V2.75a1.5 1.5 0 0 1 1.5-1.5h3M11 11.75 14.75 8m0 0L11 4.25M14.75 8h-9" }));
const ForwardRef = forwardRef(SvgLogoff);
export { ForwardRef as ReactComponent };
